import {
  CHANGE_PASSWORD_SUCCESS_MESSAGE,
  CHANGE_PASSWORD_SUCCESS_TITLE,
  GENERIC_ERROR_MESSAGE,
  GENERIC_ERROR_TITLE,
  REPEATED_PASSWORD_ERROR_MESSAGE,
  SERVER_ERROR_MESSAGE,
  SERVER_ERROR_TITLE,
} from "@/constants/messages";

export const TOAST_MESSAGES = {
  GENERIC_ERROR: {
    title: GENERIC_ERROR_TITLE,
    description: GENERIC_ERROR_MESSAGE,
  },
  SUCCESS: {
    title: CHANGE_PASSWORD_SUCCESS_TITLE,
    description: CHANGE_PASSWORD_SUCCESS_MESSAGE,
  },
  SERVER_ERROR: {
    title: SERVER_ERROR_TITLE,
    description: SERVER_ERROR_MESSAGE,
  },
  REPEATED_PASSWORD: {
    title: "",
    description: REPEATED_PASSWORD_ERROR_MESSAGE,
  },
};
